import { QuickFilterBar as FilterBar } from "components/form_components/QuickFilterBar";
import { getAppliedFilters, mergeCustomBuyersChip } from "components/form_components/utils";
import { EventDataTypes } from "lib/tracking";
import { getLeadsColumnName, LeadFilters } from "./utils";

export const filterKeyToLabel: Record<keyof LeadFilters, string> = {
  assignee: "Assignee",
  createdBy: "Created by",
  stageIds: "Stage",
  value: "Value",
  lastUpdatedDate: "Last updated",
  createdDate: "Created date",
  expiryDate: "Expiry date",
  buyers: "Buyers",
  customBuyers: "Buyers",
  buyerCategories: "Buyer type",
  buyerLists: "Buyer lists",
  buyerCountryRegions: "Buyer location",
  searchText: "",
  orderBy: "",
  order: "",
  supplierGuids: "Suppliers",
  supplierSme: "SME Supplier",
  teamIds: "Team",
};

export function QuickFilterBar({
  filters,
  onClearFilter,
  onFilterClick,
  clearAllFilters,
  isLoading,
  totalResults,
  valueSum,
}: {
  filters: LeadFilters;
  onClearFilter: (value: keyof LeadFilters) => void;
  onFilterClick: (value: keyof LeadFilters) => void;
  clearAllFilters: () => void;
  isLoading: boolean;
  totalResults: number;
  valueSum: number;
}) {
  const appliedFiltersMapped = getAppliedFilters(
    {
      ...filters,

      lastUpdatedDate: {
        ...filters.lastUpdatedDate?.filter,
        hideNulls: filters.lastUpdatedDate?.hideNulls,
      },
      expiryDate: {
        ...filters.expiryDate?.filter,
        hideNulls: filters.expiryDate?.hideNulls,
      },
      createdDate: {
        ...filters.createdDate?.filter,
        hideNulls: filters.createdDate?.hideNulls,
      },
    },
    ["order", "orderBy"],
  );

  const appliedFiltersForBar = mergeCustomBuyersChip(appliedFiltersMapped);

  return (
    <FilterBar<LeadFilters>
      appliedFilters={appliedFiltersForBar}
      isLoading={isLoading}
      totalResults={totalResults}
      filterKeyToLabel={filterKeyToLabel}
      onClear={onClearFilter}
      onFilterClick={onFilterClick}
      sortField={getLeadsColumnName(filters.orderBy)}
      dataType={EventDataTypes.buyer}
      hiddenFields={["searchText"]}
      valueSum={valueSum}
      clearAllFilters={clearAllFilters}
    />
  );
}
